import Logo from "../../Logo";
import { Col, Dropdown, Nav, Navbar, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
// The following imported components will give functionality to the topbar, more specifically the notification  profile dropdowns, and theme toggler and cart icon:
// import NotificationDropdownMenu from '../nav-items/NotificationDropdownMenu';
// import ProfileDropdownMenu from '../nav-items/ProfileDropdownMenu';
// import SearchBox from 'components/common/SearchBox';
// import ThemeToggler from 'components/common/ThemeToggler';
import ProfileDropdownMenu from "../common/ProfileDropdownMenu";
import { useAuth0 } from "@auth0/auth0-react";
import RegisterButton from "../auth/RegisterButton";
import { useNavigate, useLocation } from "react-router-dom";
import DropdownSearchBox from "../common/DropdownSearchBox";
import SearchResult from "../common/SearchResults";

const EcommerceTopbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { isAuthenticated, isLoading } = useAuth0(); // will to to conditionally render profile dropdown. if user is logged in, show profile dropdown, else show login and register buttons
  // Scroll to top handler
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling effect
    });
  };
  const handleLogoClick = () => {
    scrollToTop(); // Always scroll to top when logo is clicked
    if (location.pathname !== "/home") {
      navigate("/home"); // Navigate to /home only if not already there
    }
  };
  if (isLoading) {
    return null; // Or return a loading indicator if preferred. added this to prevent the topbar from rendering before the user is authenticated, trying to fix bug where login and reister button still show up on homeoage when user is logged in
  }

  return (
    <div className="container-small">
      <div className="ecommerce-topbar">
        <Navbar className="px-0">
          <Row className="gx-0 gy-2 w-100 flex-between-center">
            <Col md="auto" xs="4">
              <div onClick={handleLogoClick} style={{ cursor: "pointer" }}>
                <Logo />
              </div>
            </Col>
            <Col
              md="auto"
              xs="8"
              className="order-md-1 d-flex justify-content-end"
            >
              <Nav as="ul" className="navbar-nav-icons flex-row me-n2">
                {!isAuthenticated && ( // if not authenticated, show login and register buttons
                  <>

                    <Link to="" className="order-0">
                      <RegisterButton />
                    </Link>
                  </>
                )}
                {isAuthenticated && ( // logout, only appears when user is authenticated
                  <Nav.Item className="" as="li">
                    <Dropdown autoClose="outside">
                      <Dropdown.Toggle
                        as={Link}
                        to="#!"
                        className="dropdown-caret-none nav-link lh-1"
                        variant=""
                      >
                        <FeatherIcon icon="user" size={20} />
                      </Dropdown.Toggle>

                      <ProfileDropdownMenu className="mt-2" />
                    </Dropdown>
                  </Nav.Item>
                )}
                {/* <LogoutButton /> */}
              </Nav>
            </Col>
            <Col lg={6} xs={12} md={5}>
              <DropdownSearchBox
                className="" // remved navbar-top-search-box
                inputClassName="rounded-pill"
                size="sm"
                style={{ width: "auto" }}
              >
                <SearchResult onSelectSuggestion={() => {}} />
              </DropdownSearchBox>
            </Col>
          </Row>
        </Navbar>
      </div>
    </div>
  );
};

export default EcommerceTopbar;
{
  /* <Nav.Item as="li" className="d-flex align-items-center">
                  <ThemeToggler />
                  Theme toggler 
                </Nav.Item> */
}

{
  /* <Nav.Item as="li">
                  <Nav.Link
                    as={Link}
                    to="/apps/e-commerce/customer/cart"
                    className="px-2 icon-indicator icon-indicator-primary"
                  >
                    <FeatherIcon icon="shopping-cart" size={20} />
                    <span className="icon-indicator-number">1</span>
                  </Nav.Link>
                </Nav.Item> */
}

{
  /* <Nav.Item as="li">
                  <Dropdown autoClose="outside">
                    <Dropdown.Toggle
                      as={Link}
                      to="#!"
                      className="dropdown-caret-none nav-link icon-indicator icon-indicator-sm icon-indicator-danger"
                      variant=""
                    >
                      <FeatherIcon icon="bell" size={20} />
                    </Dropdown.Toggle>
                    <NotificationDropdownMenu className="mt-2" />
                  </Dropdown>
                </Nav.Item> */
}
